import React from 'react';

import styled from '@emotion/styled';

import { formateDatimeStrToNiajaTime } from '../../../utils/utils';
import Stars from '../../Badge/Stars';
import CalenderIcon from '../../Icons/CalenderIcon';

interface DataProps {
  comment?: string;
  createdAt: string;
  customerEmail: string;
  id: string;
  rating: number;
  tripDate: string;
  profilePicture?: string;
  driverName?: string;
}
interface CustomerFeedBackLogsProps {
  data?: DataProps;
}

const CustomerFeedBackLogs: React.FC<CustomerFeedBackLogsProps> = ({
  data,
}) => {
  return (
    <Container>
      <Header>
        <InfoCard>
          <Img
            src={data?.profilePicture ?? '/static/img/profilePlaceholder2.png'}
            alt='Rider Avatar'
          />

          <InfoArea>
            <InfoAreaTop>Verified User</InfoAreaTop>
            <InfoAreaDateArea>
              {formateDatimeStrToNiajaTime(data?.createdAt ?? '')}
            </InfoAreaDateArea>
          </InfoArea>
        </InfoCard>
        <Stars numStars={data?.rating ?? 0} fillOnly />
      </Header>

      <div>{data?.comment ?? 'N/A'}</div>

      <Footer>
        {/* <FooterCell>
          <LineProfileIcon />
          <FooterItem>
            <div>Assigned Driver: </div>{' '}
            <BoldFooterText>{data?.driverName ?? 'N/A'}</BoldFooterText>
          </FooterItem>
        </FooterCell> */}

        <FooterCell>
          <CalenderIcon />
          <FooterItem>
            <div>Trip Date: </div>{' '}
            <BoldFooterText>{data?.tripDate ?? 'N/A'}</BoldFooterText>
          </FooterItem>
        </FooterCell>
      </Footer>
    </Container>
  );
};

export default CustomerFeedBackLogs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 8px;
  margin-bottom: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const InfoArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 8px;
`;

const InfoAreaTop = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: black;
`;

const InfoAreaDateArea = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #6e7079;
`;

const Img = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lightGrayBg};
  padding: 12px;
`;

const FooterCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FooterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6e7079;
`;

const BoldFooterText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: black;
`;
